import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { getAwards } from './awards';
import Item from './components/Item';

import './index.scss';

interface Props {}

type Enhanced = Props & InjectedTranslateProps;

const enhance = compose<Enhanced, Props>(translate);

const b = b_.with('main-page-awards');

const Awards: React.FC<Enhanced> = ({ t }) => {
  return (
    <div className={b()} data-testid={'main-page-awards'}>
      {getAwards(t).map((award, index) => (
        <Item key={index} index={index} />
      ))}
    </div>
  );
};

export default enhance(Awards);
